import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { PioneerUtils } from 'app/event/utils/pioneer-utils';

@Directive({
  selector: '[pioneerCurrency]'
})
export class CurrencyDirective {

  private el;

  constructor(
    private elementRef: ElementRef,
    private control: NgControl
  ) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    const truncatedValue = PioneerUtils.formatDecimal(value);
    this.el.value = truncatedValue;
    this.control.control.setValue(truncatedValue);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/directives/currency.directive.ts